export const blockCategories = {
    basic: { id: 'Basic', label: 'Grundlegend' },
    navigation: { id: 'Navigation', label: 'Navigation' },
    layout: { id: 'Layout', label: 'Layout' },
    advance: { id: 'Advance', label: 'Erweitert' },
    content: { id: 'Content', label: 'Inhalte' },
    teaser: { id: 'Teaser', label: 'Teaser' },
    page: { id: 'Page', label: 'Page' },
    custom: { id: 'Custom', label: 'Benutzerdefiniert' },
    widgets: { id: 'widgets', label: 'Widgets' },
    prebuiltSections: {
        id: 'prebuilt-sections',
        label: 'Vorgefertigte Abschnitte',
        open: false,
    },
};
